<template>
  <div class="content-box">
    <heardTotal :BankObj="BankObj" :superviseType="2" :queryParamsData="warehouseData"></heardTotal>
    <div class="content-bottom">
      <div class="left">
        <div class="list-title">
          <headerTitle title="监管单据列表"></headerTitle>
          <div class="tab">
            <div class="tab-item" v-for="item in tabList" :key="item.value" @click="changeTab(item.value)" :class="{ 'active-tab': item.value == activeTab }">{{ item.label }}</div>
          </div>
        </div>
        <div class="search-box">
          <el-input size="small" placeholder="输入客户名称/电话号码检索" v-model="searchValue">
            <template slot="append">
              <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
            </template>
          </el-input>
        </div>
        <div class="item-box" @scroll="getLoad">
          <div class="item" v-for="item in list" :key="item.superviseId" @click="handleClickList(item)" :class="{ 'active-item': item.superviseId == activeList }">
            <div class="icon">
              <img v-if="item.superviseId == activeList" src="../../../../assets/back/active-user-icon.png" alt="" />
              <img v-else src="../../../../assets/back/user-icon.png" alt="" />
            </div>
            <div class="user">
              <div>{{ item?.applyName }}</div>
              <div>授信金额：{{ item?.superviseAmount }}万</div>
            </div>
            <div class="animal">库存总量: {{ item?.reserveTotalWeight||0 }}吨</div>
          </div>
          <div class=loading style='display:block;text-align:center;height:30px;line-height:30px;color: #fff;padding: 10px;'>{{ stopLoding?'已加载全部内容':'加载中...' }}</div>
        </div>
      </div>
      <div class="center">
        <div class="center-top">
          <div class="grade-box">
            <div class="name">{{supInfo?.applyName }}</div>
            <div class="grade">
              风控评级：
              <span>A</span>
            </div>
          </div>
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="bg-purple">联系电话：{{ handelPhone }}</div>
            </el-col>
            <el-col :span="15">
                <div class="bg-purple">所在区域：{{((supInfo?.provinceName||'')+'-'+(supInfo?.cityName||'')+'-'+(supInfo?.countyName||''))}}</div>
            </el-col>
          </el-row>
          <div class="supervise">
            <div class="supervise-box">
                <div>合同编号：{{ supInfo?.contractNo }}</div>
              <div>监管期限：{{supInfo?.superviseLimit||0}}个月({{(supInfo?.superviseStart||'')+'-'+(supInfo?.superviseEnd||'')}})</div>
              <div>客户经理：{{supInfo?.loanOfficerName}}</div>
              <div>授信金额：{{  supInfo?.superviseAmount||0}}万</div>
              <div>质押商品重量：{{ supInfo?.mortgageTotalWeight ||0}}吨</div>
              <div>质押商品货值：{{ supInfo?.mortgageTotalAmount||0}}万</div>
            </div>
            <div class="supervise-icon">
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.superviseAmountReceive||0}}</div>
                  <div class="statis-value">待还金额(万)</div>
                </div>
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.superviseBalanceDue||0}}</div>
                  <div class="statis-value">可用金额(万)</div>
                </div>
              </div>
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.calcWeight ||0}}</div>
                  <div class="statis-value">当前库存总重(吨)</div>
                </div>
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.calcPrice||0}}</div>
                  <div class="statis-value">当前库存货值(万)</div>
                </div>
              </div>
              <div class="supervise-icon-box" style="display:flex;justify-content: center;  align-items: center;">
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.processCount||''||'0' }}</div>
                  <div class="statis-value">预警信息</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center-bottom">
          <headerTitle title="养殖经营概况" :sourceType="2"></headerTitle>
          <div class="tab-box">
            <div class="tab-item" style="width: 310px;">
              <div class="tab-item-box" :class="{ 'tab-item-active ': item.id == activeOperate }" v-for="item in operateList" :key="item.id" @click="handleOper(item.id)">{{ item.label }}</div>
            </div>
            <div class="tab-date">
              <el-dropdown class="mydropdown" style="color: #fff; cursor: pointer" trigger="click" @command="handleDropmenu">
                <span class="el-dropdown-link"> {{ command || 2023 }}<i class="el-icon-caret-bottom el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in dropdownList" :command="item" :key="index">{{ item.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <enterprise ref="enterprise" :loanYearQuery='command' :superviseId='activeList'  v-if="activeOperate == 1"></enterprise>
          <sale v-else-if="activeOperate == 2" :loanYearQuery='command' :superviseId='activeList'></sale>
        </div>
      </div>
      <div class="right">
        <div class="device">
			<device  :businessType="'2'" :businessId="businessId"></device>
		</div>
        <div class="inspection">
            <div style="display:flex; align-items: center">
                <div class="inspection-box"></div>
                <div :class='{"inspection-title":true,"inspection-font":recordTab==1}' @click="changeCard(1)">监管日志</div>
                <div :class='{"inspection-title":true,"inspection-font":recordTab==2}' @click="changeCard(2)">巡检记录</div>
            </div>
            <div style="height: 5rem; width: 100%;">
                <timeLine :list="listT" :stopLoding="stopLodingT" :recordTab="recordTab" @getLoad="changeTabIn"></timeLine>
            </div>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTitle from '@/views/bankScreen/components/headerTitle'
import device from '@/views/bankScreen/components/device'
import heardTotal from '../components/heardTotal.vue'
import enterprise from './components/enterprise.vue'
import sale from './components/sale.vue'
import{ Desensitized} from '@/utils/desensitization.js'
import timeLine from './components/timeLine.vue'
export default {
  components: {
    headerTitle,
    heardTotal,
    enterprise,
    sale,
	device,
    timeLine
  },
  props: {
    warehouseData: {
      typeof: Object,
      default: () => {},
    },
    BankObj:{
        type:Object,
        default: () => {},
    },
  },
  watch:{
    'warehouseData':{
        handler(){
         this.pageNum=1
         this.recordTab=1
         this.listT=[]
        this.getList()
        },
        deep:true
    },
    'activeList':{
        handler(){
            this.getSupInfo()
        },
    },
  },
  data() {
    return {
	  superviseId:'1682277220694024193',
	  businessId:null,
      activeTab: 2,
      searchValue: '',
      tabList: [
        {
          label: '监管中',
          value: 2,
        },
        {
          label: '已结束',
          value: 3,
        },
      ],
      list: [],
      activeList: 1,
      activeOperate: 1,
      operateList: [
        {
          label: '企业库存',
          id: 1,
        },
        {
          label: '销售渠道',
          id: 2,
        },
      ],
      command: '2024',
      dropdownList: [
        { name: '2021', id: 1 },
        { name: '2022', id: 2 },
        { name: '2023', id: 3 },
        { name: '2024', id: 4 },

      ],
      liveStockData: [],
      pageNum:1,
      pageNumT:1,
      stopLoding:false,
      supInfo:{},
      supInfoObj:{},
      recordTab:1,
      stopLodingT:true,
      listT:[],
    }
  },
  computed:{
    handelPhone(){
        return Desensitized.desensitizedPhone(this.supInfo?.applyPhone)
    },
  },
  created() {
    this.getList()
  },
  mounted() {},

  methods: {
    changeCard(value){
		this.listT=[]
        this.recordTab=value
        this.pageNumT=1
		this.stopLoding=true
        this.changeTabIn(this.activeList)
    },

    getInspection(superviseId,url){
      if(!superviseId){
        return;
      }
        this.stopLodingT=true
        if(this.pageNumT==1){
            this.listT=[]
        }
        this.$http({  
            url:url,
            data:{
                superviseId:superviseId,
                pageNum:this.pageNumT,
                pageSize:10,
                appId:2015,
            },
            method: 'post',
        }).then((res)=>{
            if(res.data.code==200){
                this.stopLodingT=false
                let list=res.data.result.list||[]
                let total=Number(res.data.result.total) 
                if(list.length<=0){
                    this.stopLodingT=true
                    this.listT=[]
                }
                if(this.pageNumT==1){
                    this.listT=list
                }else{
                    this.listT=[...this.listT,...list]
                }
                if(this.listT.length==total){
                    this.stopLodingT=true
                }else{
                    this.pageNumT++
                }
            }
        })
    },

    changeTabIn(){
		console.log('加载更多22')
		let superviseId=this.activeList
        if(this.recordTab==1){
            this.getInspection(superviseId,'ffsapp-service/ffsSuperviseLog/pageList')
        }else{
            this.getInspection(superviseId,'ffsapp-service/superviseinspect/page')
        }
    },

    getList(){
        this.stopLoding=true
        this.$http({
            url: 'ffsapp-service/superviseProperty/queryBankSuperviseList',
			method: 'post',
            data:{
                companyTenantIds:Array.isArray(this.warehouseData.companyTenantIds)?[...this.warehouseData.companyTenantIds]:this.warehouseData.companyTenantIds.split(','),
                appId:'2015',
                ancestorsAllQuery:this.warehouseData.ancestorsAllQuery,
                companyBankType:this.warehouseData.companyBankType,
                companyTenantId:this.warehouseData.companyTenantId,
                superviseStatus:this.activeTab,
                pageNum:this.pageNum,
                pageSize:10,
                searchValue:this.searchValue,
                superviseType:2
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.stopLoding=false
                let list=res.data.result.list||[]
                let total=Number(res.data.result.total) 
                if(list.length<=0){
                    this.stopLoding=true
                    this.list=[]
                }
                if(this.pageNum==1){
                    this.list=list
                }else{
                    this.list=[...this.list,...list]
                }

                this.activeList=this.list?.[0]?.superviseId
				        this.businessId=this.list?.[0]?.storehouseId
               console.log("storehouseId:"+this.list?.[0]?.storehouseId);
              console.log("businessId:"+this.businessId);

              this.supInfo=this.list?.[0]
             
                if(this.activeList&&this.pageNum==1){
                    this.recordTab=1
                    this.pageNumT=1
                    this.changeTabIn(this.activeList)
                }
                if(this.list.length==total){
                    this.stopLoding=true
                }else{
                    this.pageNum++
                }
            }
        })
    },

        //查看详情
        getSupInfo(){
        this.$http({  
            url:'ffsapp-service/superviseProperty/queryBankSuperviseDeatil',
            data:{superviseId:this.activeList},
            method: 'post',
        }).then((res)=>{
            if(res.data.code==200){
                this.supInfoObj=res.data.result
            }
        })

    },
   //实现下拉加载
   getLoad(){
        let boxHeight=document.querySelector('.item-box').clientHeight
        let scrollHeight =document.querySelector('.item-box').scrollHeight
        let scrollTop =document.querySelector('.item-box').scrollTop
       if(scrollHeight<boxHeight+scrollTop+5){
            if(!this.stopLoding){
                this.getList()
            }
       }
    },
    changeTab(val) {
        this.activeTab = val
        this.pageNum=1
        this.list=[]
        this.listT=[]
        this.getList()
    },
    handleSearch() {
        this.pageNum=1
        this.listT=[]
        this.list=[]
        this.getList()
    },
    handleClickList(val) {
      console.log(val);

      this.activeList = val.superviseId
	   	this.businessId=val.storehouseId
        this.supInfo=val
        this.recordTab=1
        this.pageNumT=1
        this.changeTabIn(this.activeList)
    },
    handleOper(val) {
      this.activeOperate = val
    },
    handleDropmenu(command) {
      console.log(command)
      this.command = command.name
      // this.liveStockData = [20, 434, 202, 368, 280, 160, 330]
      // this.$nextTick(() => {
      //   this.$refs.livestockTrendsRef.setChart()
      // })
    },
    // 活畜动态
    getLiveStock() {
      const rawData = [
        [100, 302, 301, 334, 390, 330, 320],
        [320, 132, 101, 134, 90, 230, 210],
      ]
      const totalData = []
      for (let i = 0; i < rawData[0].length; ++i) {
        let sum = 0
        for (let j = 0; j < rawData.length; ++j) {
          sum += rawData[j][i]
        }
        totalData.push(sum)
      }
      this.liveStockData = totalData
      console.log(this.liveStockData)
    },
  },
}
</script>
<style>
.el-dropdown-menu {
  background: rgba(52, 39, 20, 1);
  border: 1px solid rgba(239, 171, 68, 0.2);

}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled) {
  color: rgba(181, 180, 178, 1);
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(239, 171, 68, 0.2);
  color: rgba(181, 180, 178, 1);
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
  border-bottom-color: rgba(239, 171, 68, 0.2);
}

.el-popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: rgba(239, 171, 68, 0.2);
  top: -7px;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
  border-bottom-color: rgba(239, 171, 68, 0.2);
}
</style>
<style scoped lang="scss">
@import './index.scss';


</style>
